import api from '@/helpers/api.js';

export default {
  async getHistory(userId) {
    var data = await api.get('/UserHistory', { userId: userId });
    return data;
  }
};
